// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"styles_switchContainer__U-9ZM"};